import { render, staticRenderFns } from "./MoleculeEditionProductArtificialIntelligenceCreditos.vue?vue&type=template&id=4b14063a&"
import script from "./MoleculeEditionProductArtificialIntelligenceCreditos.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductArtificialIntelligenceCreditos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports